class BrPrintSelector extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.mobile = matchMedia('(max-width: 749px)');
    this.addEventListener('click', this.onClick, { signal: this.controller.signal });
    this.mobile.addEventListener('change', this.update, { signal: this.controller.signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  onClick = (event) => {
    if (event.target instanceof Element && event.target.closest('[data-br-print-toggle]')) {
      this.dataset.expanded = String(this.dataset.expanded !== 'true');
      this.update();
    }
  };
  update = () => {
    const items = [...this.querySelectorAll('[data-br-print-item]')];
    const expanded = this.dataset.expanded === 'true';
    const limit = Number(this.dataset.mobileLimit) || 5;
    items.forEach((item, index) => { item.hidden = this.mobile.matches && !expanded && index >= limit; });
    const toggle = this.querySelector('[data-br-print-toggle]');
    if (!toggle) return;
    toggle.hidden = !this.mobile.matches || items.length <= limit;
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
  };
}
if (!customElements.get('br-print-selector')) customElements.define('br-print-selector', BrPrintSelector);
